import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { applyDocumentMetadata } from "../CanonicalUrl";
import { getEventPageMetadata } from "../eventSharing";

export default function EventPageMetadata({ event }) {
  const { pathname } = useLocation();

  useEffect(() => {
    const metadata = getEventPageMetadata(event);
    applyDocumentMetadata({
      ...metadata,
      robots: "index,follow",
    });
  }, [event, pathname]);

  return null;
}
